import { c as _c } from "react/compiler-runtime";
import SignUpView from "@repo/ui/components/auth/SignUpView";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { authClient } from "@/clients/authClient";
import { trpcClient } from "@/clients/trpcClient";
import { signUpSearchSchema } from "@/lib/schemas/searchParams.schema";
import { decodeStatusParam } from "@/lib/utils/statusParam";
import { verificationRedirectUrl } from "@/lib/utils/verificationRedirect";
import { jsx as _jsx } from "react/jsx-runtime";
export const Route = createFileRoute("/_public/_auth/skapa-konto")({
  component: SignUpPage,
  validateSearch: signUpSearchSchema
});
function SignUpPage() {
  const $ = _c(17);
  const navigate = useNavigate();
  const search = Route.useSearch();
  const t0 = search.meddelande || search.bekraftelsemeddelande;
  let t1;
  if ($[0] !== t0) {
    t1 = decodeStatusParam(t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const decoded = t1;
  let t2;
  if ($[2] !== decoded || $[3] !== search.meddelande) {
    t2 = decoded ? {
      message: decoded,
      variant: search.meddelande ? "success" : "confirmation"
    } : undefined;
    $[2] = decoded;
    $[3] = search.meddelande;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const statusMessage = t2;
  const handlePrivacyPolicyClick = _temp;
  const handleTermsClick = _temp2;
  let t3;
  if ($[5] !== navigate) {
    t3 = () => navigate({
      to: "/logga-in"
    });
    $[5] = navigate;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== navigate) {
    t4 = () => navigate({
      to: "/logga-in"
    });
    $[7] = navigate;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = verificationRedirectUrl("/");
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = statusMessage;
  let t7;
  if ($[10] !== navigate) {
    t7 = () => navigate({
      to: "/skapa-konto"
    });
    $[10] = navigate;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t6 || $[15] !== t7) {
    t8 = /*#__PURE__*/_jsx(SignUpView, {
      authClient: authClient,
      trpcClient: trpcClient,
      onSignUpComplete: t3,
      signUpCompleteLabel: "Till inloggningen",
      onBackToSignIn: t4,
      onPrivacyPolicyClick: handlePrivacyPolicyClick,
      onTermsClick: handleTermsClick,
      verificationRedirectUrl: t5,
      statusMessage: t6,
      onStatusMessageAction: t7
    });
    $[12] = t3;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}
function _temp2() {
  window.open("/om/villkor", "_blank");
}
function _temp() {
  window.open("/om/integritet", "_blank");
}